import { RecentCheckedItemRepository } from '../../repositories/recent_checked_item/recent_checked_item_repository';
import { RecentCheckedItem } from '../../models/recent_checked_item/recent_checked_item';
import { RecentCheckedItemJsEnv } from '../../models/recent_checked_item/recent_checked_item_js_env';
import { TypedEvent } from '../../typed_event';
import { RecentCheckedItemContainer } from '../../views/pc/recent_checked_item/recent_checked_item_container';
import { JsEnv, getSiteTypeValue } from '../../models/js_env';
import { AddCartModalAction } from '../add_cart/modal_action';
import { AddCartButtonRequest } from '../../models/add_cart/modal_js_env';

export class RecentCheckedItemAction {
  static readonly UPDATE_EVENT = new TypedEvent<RecentCheckedItemJsEnv>();
  private static state: RecentCheckedItem;
  private static recentCheckedItemRepository: RecentCheckedItemRepository;
  static async init(env: JsEnv) {
    this.recentCheckedItemRepository = new RecentCheckedItemRepository();
    this.state = new RecentCheckedItem(
      await this.recentCheckedItemRepository.getRecentCheckedItems(env.SITE_TYPE, env.PAGE.isLogin)
    );
    AddCartModalAction.bindClickAddCartToWindow();
    new RecentCheckedItemContainer(this.state.getModel()); // NOSONAR
  }

  static async AddCart(targetElement: HTMLElement, supplierId: string, catalogItemCode: string) {
    AddCartModalAction.addCart(
      targetElement,
      new AddCartButtonRequest(
        supplierId,
        catalogItemCode,
        // 数量の入力要素がないため1件で固定
        1,
        getSiteTypeValue()
      ),
      '',
      '',
      catalogItemCode
    );
  }

  static async delete(supplierId: string, catalogItemCode: string) {
    const model = this.state.getModel();
    await this.recentCheckedItemRepository.delete(
      model.siteType,
      model.isLogin,
      supplierId,
      catalogItemCode
    );

    this.state.updateModel(supplierId, catalogItemCode);

    // いったん、削除ボタン押下時のDOMの書き換えは、デザイン側のJS（common.js）で行うことに。
    // 将来的にこちらも利用するかもしれないため、削除ではなくコメントアウトしている。
    // this.UPDATE_EVENT.trigger(this.state.getModel())
  }
}
